<template>
  <div class="product-items-view-container">
    <table
      class="product-items-view-table"
      cellpadding="0"
      cellspacing="0"
    >
      <table-header
        class="product-items-view-table__header"
        :enabled-columns="enabledColumns"
        :is-vat-zero="isVatZero"
      />
      <table-body
        :enabled-columns="enabledColumns"
        :is-vat-zero="isVatZero"
        :items="items"
      />
    </table>
  </div>
</template>

<script>
  import TableHeader from './TableHeader';
  import TableBody from './TableBody';
  export default {
    components: { TableHeader, TableBody },
    props: {
      enabledColumns: {
        type: Array,
        default() {
          return ['product', 'productPackType', 'expirationDate', 'count', 'unitPrice', 'netPrice', 'vat'];
        },
        required: false,
      },
      isVatZero: {
        type: Boolean,
        default() {
          return false;
        },
        required: false,
      },
      items: {
        type: Array,
        default() {
          return [];
        },
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  $borderColor: #EBEEF5;
  $headerColor: #909399;

  .product-items-view-container {
    .product-items-view-table {
      border-left: 1px solid $borderColor;
      border-top: 1px solid $borderColor;
      width: 100%;

      td {
        border-right: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        padding: 12px 10px;
        margin-bottom: -1px;
        vertical-align: top;
      }

      .product-items-view-table__header {
        color: $headerColor;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
</style>
